export default __webpack_public_path__ + "static/media/icons8-human.e627b4b4.svg";